//服务收费单申请
<template>
	<Page ref="page" v-loading="loading" :showReturn="!isCreate">
		<div>
			<el-form ref="form" label-width="140px" :model="params" :rules="rules">
				<div class="cm-flex-line">
					<el-form-item label="订单日期：" prop="orderTime" :rules="rules.orderTime">
						<el-date-picker style="width: 100%" v-model="params.orderTime" placeholder="请选择日期"
							value-format="yyyy-MM-dd" :disabled="!isFieldEditable()" :picker-options="{
								disabledDate(time) {
									return time.getTime() > Date.now()
								}
							}" />
					</el-form-item>
					<el-form-item label="关联工单号：" prop="workOrderCode">
						<SelectPagination style="width: 100%" :default-value="params.workOrderCode"
							:get-list-methods="listWorkOrderNo" :clearable="true" search-key="workOrderCode"
							:disabled="!isFieldEditable()" @selectedChange="changeWorkOrderCode" />
					</el-form-item>

					<el-form-item label="销售类型：" prop="sellType">
						<el-select style="width: 100%" v-model="params.sellType" :disabled="!isFieldEditable()">
							<el-option :label="a.label" :value="a.value" :key="a.value"
								v-for="a in $constant.sellType"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="cm-flex-line">
					<el-form-item label="业务员：" prop="salesmanCode">
						<SelectProposer :code.sync="params.salesmanCode" :name.sync="params.salesmanName"
							:disabled="!isFieldEditable()" @change="proposerChange" />
					</el-form-item>

					<el-form-item label="销售部门：" prop="salesDepartmentCode">
						<SelectDepartment ref="SelectDepartment" :code.sync="params.salesDepartmentCode"
							:name.sync="params.salesDepartmentName" :disabled="true" />
					</el-form-item>
					<el-form-item label="所属区域：" prop="area">
						<el-cascader v-model="params.area" :props="casProps" :options="casOptions"
							:disabled="!isFieldEditable()" style="width: 100%"></el-cascader>
					</el-form-item>
				</div>
				<div class="cm-flex-line">
					<el-form-item label="客户名称：" prop="clientCode">
						<SelectCustomer :code.sync="params.clientCode" :name.sync="params.clientName" :disabled="!isFieldEditable()" />
					</el-form-item>
					<el-form-item label="付款方式：" prop="payWay">
						<el-select style="width: 100%" v-model="params.payWay" :disabled="!isFieldEditable()" @change="changePayment">
							<el-option :label="a.label" :value="a.value" :key="a.value"
								v-for="a in $constant.payWay"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="要求发货日期：" prop="requireDeliverTime">
						<el-date-picker style="width: 100%" v-model="params.requireDeliverTime" placeholder="请选择日期"
							value-format="yyyy-MM-dd" :disabled="!isFieldEditable()" :picker-options="{
								disabledDate(time) {
									return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
								}
							}" />
					</el-form-item>
				</div>
				<div class="cm-flex-line">
					<el-form-item label="联系人：" prop="linkman">
						<el-input v-model="params.linkman" placeholder="请输入联系人" :disabled="!isFieldEditable()"></el-input>
					</el-form-item>
					<el-form-item label="联系人电话：" prop="linkmanPhone">
						<el-input v-model="params.linkmanPhone" placeholder="请输入联系人电话" :disabled="!isFieldEditable()"></el-input>
					</el-form-item>
					<el-form-item label="联系人地址：" prop="linkmanAddress">
						<el-input v-model="params.linkmanAddress" placeholder="请输入联系人地址" :disabled="!isFieldEditable()"></el-input>
					</el-form-item>
				</div>
				<div class="cm-flex-line">
					<el-form-item label="上门安装：" prop="installType">
						<el-select style="width: 100%" v-model="params.installType" :disabled="!isFieldEditable()">
							<el-option label="否" :value="0"></el-option>
							<el-option label="是" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="保修方式：" prop="maintenanceType">
						<el-select style="width: 100%" v-model="params.maintenanceType" :disabled="!isFieldEditable()">
							<el-option :label="a.label" :value="a.value" :key="a.value"
								v-for="a in $constant.maintenanceType"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="工厂维修：" prop="send">
						<el-radio-group v-model="params.send" :disabled="!isFieldEditable()" @change="changeSend">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<div class="cm-flex-line">
					<el-form-item label="物流信息：" prop="logistics" v-if="params.send === 1">
						<el-input v-model="params.logistics" placeholder="请输入联系人" :disabled="!isFieldEditable()"></el-input>
					</el-form-item>
					<el-form-item prop="repair" label="是否确认维修：" v-if="params.send === 1">
						<el-radio-group v-model="params.repair" :disabled="!isFieldEditable('UPDATE_REPAIR_CONFIRM')" @change="changeRepair">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item prop="accessories" label="工厂寄送配件：" v-if="params.send === 0">
						<el-radio-group v-model="params.accessories" :disabled="!isFieldEditable()" @change="changeAccessories">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<el-form-item label="备注：" prop="remark">
					<el-input v-model="params.remark" placeholder="请输入备注" type="textarea" maxlength="255"
						show-word-limit :disabled="!isFieldEditable()"></el-input>
				</el-form-item>
				<el-form-item prop="fileList" label="附件：">
					<UploadFile ref="UploadFile" v-model="params.fileList" :showAccept="false" :limit="10" multiple
						:disabled="!isFieldEditable()" :preAppendixAddr="params && params.attachmentUrl" />
				</el-form-item>
				<el-form-item prop="imageList1" label="收费相关附件：">
					<UploadImage ref="UploadImage" v-model="params.imageList1" :showAccept="false" :limit="10" multiple
						:disabled="!isFieldEditable('UPDATE_PAYMENT')" :preAppendixAddr="params && params.payUrl" />
				</el-form-item>
				<el-form-item prop="imageList2" label="维修相关附件：">
					<UploadImage ref="UploadImage" v-model="params.imageList2" :showAccept="false" :limit="10" multiple
						:disabled="!isFieldEditable('UPDATE_REPAIR')" :preAppendixAddr="params && params.repairUrl" />
				</el-form-item>
				<el-divider content-position="left" v-if="params.send === 1">设备信息</el-divider>
				<div class="cm-flex-line" v-if="params.send === 1">
					<el-form-item label="设备料号：" prop="code">
						<SelectGoodsCode :code.sync="params.code" :name.sync="params.name" :disabled="!isFieldEditable()" />
					</el-form-item>
					<el-form-item label="设备名称：" prop="name">
						<SelectGoodsName :code.sync="params.code" :name.sync="params.name" :disabled="!isFieldEditable()" />
					</el-form-item>
					<el-form-item label="设备SN：" prop="sn">
						<el-input
							v-model="params.sn"
							placeholder="设备sn"
							:disabled="!isFieldEditable()"
							@input="onSnInput"
						></el-input>
					</el-form-item>
					<el-form-item label="保修状态：" prop="insuredStatus">
						<span
							:style="{ color: insuredStatus === 1 ? '#67C23A' : insuredStatus === 0 ? '#F56C6C' : '#909399' }">
							{{ insuredStatus === 1 ? '在保' : insuredStatus === 0 ? '过保' : '未知' }}
						</span>
					</el-form-item>
				</div>
				<el-form-item label="故障现象" prop="detail" v-if="params.send === 1">
					<el-input v-model="params.detail" placeholder="请输入故障现象" :disabled="!isFieldEditable()"></el-input>
				</el-form-item>
				<el-divider content-position="left">维修清单</el-divider>
				<div style="display: flex; justify-content: start; margin-bottom: 5px">
					<el-button type="primary" icon="el-icon-plus" size="mini" :disabled="!isFieldEditable('UPDATE_DETAILS')" @click="addGroupEvent()">
						添加维修项
					</el-button>
				</div>
				<el-collapse v-model="activeNames">
					<el-collapse-item v-for="(group, groupIndex) in detailGroups" :key="groupIndex" :name="groupIndex">
						<template slot="title">
							<div style="display: flex; align-items: center; flex-wrap: wrap; gap: 24px;">
								<div style="display: flex; align-items: center;">
									<el-form-item label="故障原因：" label-width="100px"
										:prop="getDetailProp(group[0], 'reason')" :rules="rules.reason"
										style="margin-bottom: 0;">
										<el-input v-model="group[0].reason" placeholder="请输入故障原因" size="mini"
											style="width: 200px;" :disabled="!isFieldEditable('UPDATE_DETAILS')" @click.stop.native @keydown.native.stop.prevent.space
											@keydown.native.stop.prevent.enter @keyup.native.stop.prevent.space
											@keyup.native.stop.prevent.enter />
									</el-form-item>
								</div>
								<div style="display: flex; align-items: center;">
									<el-form-item label="维修项：" label-width="100px"
										:prop="getDetailProp(group[0], 'maintenance')" :rules="rules.maintenance"
										style="margin-bottom: 0;">
										<el-input v-model="group[0].maintenance" placeholder="请输入维修项名称" size="mini"
											style="width: 180px;" :disabled="!isFieldEditable('UPDATE_DETAILS')" @click.stop.native @keydown.native.stop.prevent.space
											@keydown.native.stop.prevent.enter @keyup.native.stop.prevent.space
											@keyup.native.stop.prevent.enter />
									</el-form-item>
								</div>
								<div style="display: flex; align-items: center; width: 200px;">
									<el-form-item label="维修金额：" label-width="100px" style="margin-bottom: 0;">
										<span style="color: #e6a23c; margin-right: 4px;">
											{{group.reduce((sum, item) => sum + item.totalAmount, 0) | dividedInto}}
										</span>
										<span>元</span>
									</el-form-item>
								</div>
								<el-button type="primary" size="mini" :disabled="!isFieldEditable('UPDATE_DETAILS')" @click.stop="addEvent(group, groupIndex)"
									style="margin-left: auto;">
									添加明细
								</el-button>
							</div>
						</template>
						<el-table :data="group">
							<el-table-column header-align="center" label="料号" min-width="140">
								<template slot-scope="{ row, $index }">
									<el-tooltip
										effect="dark"
										placement="top"
										:content="row.code"
										:disabled="!row.code"
									>
										<div>
											<el-form-item
												label=""
												label-width="0"
												:prop="getDetailProp(row, 'code')"
												:rules="rules.code"
											>
												<SelectGoodsCode
													:code.sync="row.code"
													:name.sync="row.name"
													:bserial.sync="row.bserial"
													:disabled="!isFieldEditable('UPDATE_DETAILS')"
												/>
											</el-form-item>
										</div>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="名称" min-width="140">
								<template slot-scope="{ row, $index }">
									<el-tooltip
										effect="dark"
										placement="top"
										:content="row.name"
										:disabled="!row.name"
									>
										<div>
											<el-form-item
												label=""
												label-width="0"
												:prop="getDetailProp(row, 'name')"
												:rules="rules.name"
											>
												<SelectGoodsName
													:code.sync="row.code"
													:name.sync="row.name"
													:bserial.sync="row.bserial"
												/>
											</el-form-item>
										</div>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="单价" width="100">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0" :prop="getDetailProp(row, 'price')"
										:rules="rules.price">
										<el-input v-model="row.price" placeholder="单价" :disabled="!isFieldEditable('UPDATE_DETAILS')" @input="
											val =>
											(row.price =
												$format.fmtAmt(val))
										" @blur="computeTotalAmount(row)"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="数量" width="100">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0" :prop="getDetailProp(row, 'num')"
										:rules="rules.num">
										<el-input v-model="row.num" placeholder="数量" :disabled="!isFieldEditable('UPDATE_DETAILS') || (row.bserial && params.send === 0 && params.accessories === 0)" @input="
											val =>
											(row.num =
												$format.fmtNumber(val))
										" @blur="computeTotalAmount(row)"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column header-align="center" align="center" label="小计费用" width="100">
								<template slot-scope="{ row, $index }">
									<div style="margin-bottom: 22px">
										{{ group[$index].totalAmount | dividedInto }}
									</div>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="仓库" width="140">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0" :prop="getDetailProp(row, 'warehouseCode')"
										:rules="rules.warehouseCode">
										<SelectWarehouse :code.sync="row.warehouseCode" :name.sync="row.warehouseName"
											:disabled="!isFieldEditable('UPDATE_DETAILS')" @change="changeWarehouse" :inventoryCode="row.code" />
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="货位" width="140">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0" :prop="getDetailProp(row, 'storageCode')"
										:rules="rules.storageCode">
										<SelectGoodsLocation :ref="'SelectGoodsLocation' + getDetailIndex(row)"
											:code.sync="row.storageCode" :name.sync="row.storageName"
											:disabled="!isFieldEditable('UPDATE_DETAILS')" :maxNum.sync="row.inventoryNum" :params="{
												inventoryCode: row.code,
												warehouseCode:
													row.warehouseCode
											}" />
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="SN" v-if="params.send === 0 && params.accessories === 0" width="180">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0" :prop="getDetailProp(row, 'sn')">
										<SelectSn
										  :ref="'SelectSn' + $index"
										  :code.sync="row.sn"
										  :name.sync="row.sn"
										  :params="{
										    cInvCode: row.code,
										    cWhCode: row.warehouseCode,
										    cPosCode: row.storageCode,
											bserial: row.bserial
										  }"
										  multiple
										   :disabled="!isFieldEditable('UPDATE_DETAILS') || (!row.bserial || !row.storageCode || !row.warehouseCode)"
										   :inputDisabled="!isFieldEditable('UPDATE_DETAILS') || (!row.bserial || !row.storageCode || !row.warehouseCode)"
											@change="(val) => { row.num = val.length, computeTotalAmount(row)}"
										/>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="存货数量" width="100">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0">
										<el-input v-model="row.inventoryNum" placeholder="" disabled></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label="备注" min-width="140">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0" :prop="getDetailProp(row, 'remark')">
										<el-input v-model="row.remark" placeholder="请输入备注" :disabled="!isFieldEditable('UPDATE_DETAILS')"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column header-align="center" label=" " width="100">
								<template slot-scope="{ row, $index }">
									<el-form-item label="" label-width="0">
										<el-button type="text" :disabled="!isFieldEditable('UPDATE_DETAILS')" @click="deleteEvent(groupIndex, $index)">
											删除
										</el-button>
										<el-button type="text" :disabled="!isFieldEditable('UPDATE_DETAILS')" @click="copyEvent(groupIndex, $index)">
											复制
										</el-button>
									</el-form-item>
								</template>
							</el-table-column>
							<template slot="empty">
								<div>暂无数据，请添加</div>
							</template>
						</el-table>
					</el-collapse-item>
				</el-collapse>
				<div class="cm-flex-line" style="margin-top: 20px">
					<el-form-item label="费用合计：" prop="priceTotal">
						<el-input v-model="params.priceTotal" placeholder="请输入总费用（元）"
							:disabled="!isFieldEditable('UPDATE_DETAILS')" @input="val => (params.priceTotal = $format.fmtAmt(val))"></el-input>
					</el-form-item>
					<el-form-item label="有无特价：" prop="specialHas" style="flex: inherit; width: 200px">
						<el-switch v-model="params.specialHas" :active-value="1" :inactive-value="0" :disabled="!isFieldEditable('UPDATE_DETAILS')"></el-switch>
					</el-form-item>
					<el-form-item label="" label-width="30px" prop="specialOrderCode">
						<el-input v-model="params.specialOrderCode" placeholder="特价单号" :disabled="!isFieldEditable('UPDATE_DETAILS')" v-show="params.specialHas" />
					</el-form-item>
					<el-form-item label="" label-width="30px" prop="specialAmount">
						<el-input v-model="params.specialAmount" placeholder="特价价格" :disabled="!isFieldEditable('UPDATE_DETAILS')" v-show="params.specialHas" />
					</el-form-item>
				</div>
			</el-form>
		</div>
		<FlowableStep orderType="41" :variables="variables" @initNode="setNodes" @refresh="setAuditors" v-if="!isUpdate"></FlowableStep>
		<template slot="bottom">
			<el-button type="primary" @click="submitEvent(1)" style="margin-right: 10px" v-if="!isUpdate">
				提交申请
			</el-button>
			<el-button type="info" @click="submitEvent(2)" v-if="!isUpdate">保存草稿</el-button>
			<el-button type="info" @click="submitEvent(3)" v-else>保存数据</el-button>
		</template>
	</Page>
</template>

<script>
import FlowableStep from '@/components/FlowableStep'
import SelectPagination from '@/components/SelectPagination'
import applyMixins from '../../mixins/applyMixins'
export default {
	mixins: [applyMixins],
	components: {
		FlowableStep,
		SelectPagination
	},
	data() {
		let self = this
		return {
			listWorkOrderNo: this.$api.workOrder.listWorkOrderNo,
			rules: {
				orderTime: [{
					required: true,
					message: '请选择订单日期'
				}],
				sellType: [{
					required: true,
					message: '请选择销售类型'
				}],
				businessType: [{
					required: true,
					message: '请选择业务类型'
				}],
				maintenanceType: [{
					required: true,
					message: '请选择保修方式'
				}],
				maintenance: [{
					required: true,
					message: '请输入维修项名称'
				}],
				reason: [{
					required: true,
					message: '请输入故障原因'
				}],
				salesDepartmentCode: [{
					required: true,
					message: '请选择销售部门'
				}],
				area: [{
					required: true,
					message: '请选择所属区域'
				}],
				salesmanCode: [{
					required: true,
					message: '请选择业务员'
				}],
				clientCode: [{
					required: true,
					message: '请选择客户名称'
				}],
				payWay: [{
					required: true,
					message: '请选择付款方式'
				}],
				requireDeliverTime: [{
					required: true,
					message: '请选择发货日期'
				}],
				linkman: [{
					required: true,
					message: '请输入联系人'
				}],
				linkmanPhone: [{
					required: true,
					message: '请输入联系人手机'
				}],
				linkmanAddress: [{
					required: true,
					message: '请输入联系人地址'
				}],
				send: [{
					required: true,
					message: '请选择是否工厂维修'
				}],
				logistics: [{
					required: true,
					message: '请输入物流信息'
				}],
				repair: [{
					required: true,
					message: '请选择是否确认维修'
				}],
				accessories: [{
					required: true,
					message: '请选择是否工厂寄送配件'
				}],
				specialAmount: [{
					validator: (rule, value, callback) => {
						if (this.params.specialHas == 1 && !value) {
							callback('请输入特价后价格')
						} else {
							callback()
						}
					}
				}],
				num: [{
					required: true,
					validator: (rule, value, callback) => {
						const num = Number(value)
						if (!value || num === 0) {
							return callback('请输入非0整数')
						}
						// 校验：数量 <= 存货数量（inventoryNum）
						try {
							// rule.field 形如 'detailUpdateInput.3.num'
							const index = rule.field?.split('.')[1]
							const row = this.params.detailUpdateInput[index]
							const inventoryNum = Number(row?.inventoryNum || 0)
							if (inventoryNum && num > inventoryNum) {
								return callback('数量不能大于存货数量')
							}
						} catch (e) {
							console.log(e)
						}
						return callback()
					}
				}],
				price: [{
					required: true,
					message: '请输入'
				}],
				code: [{
					required: true,
					message: '请选择'
				}],
				name: [{
					required: true,
					message: '请选择'
				}],
				detail: [{
					required: true,
					message: '请输入故障详情'
				}],
				warehouseCode: [{
					required: true,
					message: '请选择'
				}],
				storageCode: [{
					required: false,
					validator: (rule, value, callback) => {
						try {
							// rule.field 形如 'detailUpdateInput.3.storageCode'
							let index = rule.field?.split('.')[1]
							const $elem = this.$refs['SelectGoodsLocation' + index]
							const refTarget = Array.isArray($elem) ? $elem[0] : $elem
							const list = refTarget?.list || []
							if (list.length > 0 && !value) {
								callback('请选择货位')
							} else {
								callback()
							}
						} catch (e) {
							console.log(e)
						}
					}
				}]
			},
			insuredStatus: undefined,
			params: {
				// 基础信息默认值，与老表单保持一致，避免校验字段不存在
				orderTime: '',
				workOrderCode: '',
				sellType: 2,
				businessType: 1,
				salesmanCode: '',
				salesmanName: '',
				salesDepartmentCode: '',
				salesDepartmentName: '',
				area: [],
				clientCode: '',
				clientName: '',
				payWay: '',
				requireDeliverTime: '',
				linkman: '',
				linkmanPhone: '',
				linkmanAddress: '',
				installType: undefined,
				maintenanceType: undefined,
				send: undefined,
				logistics: '',
				accessories: undefined,
				remark: '',
				fileList: [],
				imageList1: [],
				imageList2: [],
				code: '',
				name: '',
				sn: '',
				description: '',
				priceTotal: '',
				specialHas: 0,
				specialOrderCode: '',
				specialAmount: '',
				detailUpdateInput: [],
				auditors: {}
			},
			// 按维修项分组后的二维明细数组，例如 [[item1, item2], [item3, ...]]
			detailGroups: [],
			// 控制折叠面板展开的项（数组，元素为 groupIndex）
			activeNames: [],
			nodes: [],
			variables: {
				PAY_WAY: '', // 付款方式
				SEND: '', // 是否工厂维修
				ACCESSORIES: '', // 是否工厂寄送配件
				REPAIR: '', // 是否确认维修
				WAREHOUSE_OUT: '', // 出库仓库
			},
			casOptions: [], //省市区默认
			casProps: {
				lazy: true,
				async lazyLoad(node, resolve) {
					const {
						level
					} = node
					let list = []
					if (level === 0) {
						list = await self.$api.common.getProvince({
							page: 1,
							limit: 1000
						})
						list = (list || []).map(a => {
							return {
								label: a.province,
								value: a.provinceId
							}
						})
					} else if (level === 1) {
						list = await self.$api.common.getCity({
							province: node.data.value
						})
						list = (list || []).map(a => {
							return {
								label: a.city,
								value: a.cityId
							}
						})
					} else if (level === 2) {
						list = await self.$api.common.getArea({
							city: node.data.value
						})
						list = (list || []).map(a => {
							return {
								label: a.area,
								value: a.areaId,
								leaf: true
							}
						})
					}

					resolve(list)
				}
			}
		}
	},
	watch: {
		// 监听SN变化，自动更新保修状态
		'params.sn'(val) {
			if (val) {
				this.onSnBlur()
			} else {
				this.insuredStatus = undefined
			}
		},
		//监听计算费用合计
		'params.detailUpdateInput': {
			immediate: true,
			deep: true,
			handler(newV, oldV) {
				if (newV.length === 0) {
					this.$set(this.params, 'priceTotal', '')
				} else {
					let sum = 0
					newV.forEach(a => {
						if (a.totalAmount > 0) {
							sum += a.totalAmount
						}
					})
					this.$set(this.params, 'priceTotal', sum)
				}
			}
		}
	},
	computed: {
		isCreate() {
			return !this.$route.query.edit
		},
		isUpdate() {
			return this.$route.query.auths
		}
	},
	async mounted() {
		this.loading = true
		this.init()
		this.loading = false
	},
	methods: {
		// 检查字段是否可编辑：当isUpdate为true时，需要检查对应的权限
		// permission: 权限名称（字符串）、逗号拼接的权限字符串（如'UPDATE_DETAILS,UPDATE_PAYMENT'）或权限数组
		// 如果不传或为null，则isUpdate为true时默认不可编辑
		// 如果传入多个权限（数组或逗号拼接字符串），只要任意一个权限满足即可编辑（OR逻辑）
		isFieldEditable(permission) {
			if (!this.isUpdate) {
				return true // 非更新模式，可编辑
			}
			// 更新模式，如果没有传权限，默认不可编辑
			if (!permission) {
				return false
			}
			// 如果是数组，检查数组中是否有任意一个权限满足
			if (Array.isArray(permission)) {
				return permission.some(auth => this.hasUpdateAuth(auth))
			}
			// 如果是字符串，检查是否包含逗号（逗号拼接的权限）
			if (typeof permission === 'string' && permission.includes(',')) {
				const permissions = permission.split(',').map(p => p.trim()).filter(p => p)
				return permissions.some(auth => this.hasUpdateAuth(auth))
			}
			// 单个权限字符串，检查该权限是否满足
			return this.hasUpdateAuth(permission)
		},
		changePayment(val) {
			this.variables['PAY_WAY'] = val
			this.variables['WAREHOUSE_OUT'] =
				this.params.detailUpdateInput
					?.filter(item => item.warehouseCode)
					.map(item => item.warehouseCode) || []
			this.variables['SEND'] = this.params.send
			this.variables['ACCESSORIES'] = this.params.accessories
			this.variables['REPAIR'] = this.params.repair
		},
		changeRepair(val) {
			this.variables['PAY_WAY'] = this.params.payWay
			this.variables['WAREHOUSE_OUT'] =
				this.params.detailUpdateInput
					?.filter(item => item.warehouseCode)
					.map(item => item.warehouseCode) || []
			this.variables['SEND'] = this.params.send
			this.variables['ACCESSORIES'] = this.params.accessories
			this.variables['REPAIR'] = this.params.repair
		},
		changeWarehouse(val) {
			this.variables['PAY_WAY'] = this.params.payWay
			this.variables['WAREHOUSE_OUT'] =
				this.params.detailUpdateInput
					?.filter(item => item.warehouseCode)
					.map(item => item.warehouseCode) || []
			this.variables['SEND'] = this.params.send
			this.variables['ACCESSORIES'] = this.params.accessories
			this.variables['REPAIR'] = this.params.repair
		},
		changeSend(val) {
			if (val === 0) {
				this.params.repair = null
				this.params.logistics = ''
				this.params.code = ''
				this.params.name = ''
				this.params.sn = ''
				this.params.detail = ''
			}
			this.variables['PAY_WAY'] = this.params.payWay
			this.variables['WAREHOUSE_OUT'] =
				this.params.detailUpdateInput
					?.filter(item => item.warehouseCode)
					.map(item => item.warehouseCode) || []
			this.variables['SEND'] = this.params.send
			this.variables['ACCESSORIES'] = this.params.accessories
			this.variables['REPAIR'] = this.params.repair
		},
		changeAccessories(val) {
			this.variables['PAY_WAY'] = this.params.payWay
			this.variables['WAREHOUSE_OUT'] =
				this.params.detailUpdateInput
					?.filter(item => item.warehouseCode)
					.map(item => item.warehouseCode) || []
			this.variables['SEND'] = this.params.send
			this.variables['ACCESSORIES'] = this.params.accessories
			this.variables['REPAIR'] = this.params.repair
		},
		onSnInput(value) {
			// 只保留非中文非空格字符
			this.params.sn = (value || '').replace(/[\u4e00-\u9fa5|\s]/g, '')
		},
		async onSnBlur() {
			const sn = this.params.sn
			if (sn) {
				this.insuredStatus = await this.$api.apply.keepService(sn)
			} else {
				this.insuredStatus = undefined
			}
		},
		setNodes(nodes) {
			this.nodes = nodes
		},
		setAuditors(auditors) {
			this.params.auditors = auditors
		},
		async init() {
			try {
				const {
					orderCode,
					workOrderCode = ''
				} = this.$route.query
				if (workOrderCode) {
					let data = await this.$api.workOrder.getWorkOrder({
						workOrderCode: workOrderCode
					})
					let params = {
						workOrderCode: data.workOrderCode,
						linkman: data.linkedHuman,
						linkmanPhone: data.linkedHumanPhone,
						remark: data.description,
						auditors: {},
						detailUpdateInput: [],
						businessType: 1,
						sellType: 2,
						specialHas: 0
					}
					this.params = params
				} else {
					const res = await this.$api.apply.sellOrderInfo({
						orderCode
					})
					if (res) {
						let {
							sellOrderResult,
							detailResults
						} = res
						sellOrderResult.specialHas = sellOrderResult.specialAmount ? 1 : 0
						sellOrderResult.specialAmount = sellOrderResult.specialAmount ?
							sellOrderResult.specialAmount / 100 :
							''
						// 明细价格、金额由分转为元，并保留仓库等字段
						const sources = (detailResults || []).map(a => ({
							...a,
							price: a.price / 100,
							totalAmount: a.totalAmount / 100
						}))
						// 初始化分组数据（使用转换后的明细）
						this.buildDetailGroups(sources)
						sellOrderResult.area = [
							sellOrderResult.provinceId,
							sellOrderResult.cityId,
							sellOrderResult.areaId
						]
						// 将转换后的明细放入响应式 params 中，避免替换整个 params 对象导致监听异常
						const baseParams = {
							...sellOrderResult,
							auditors: {}
						}
						// 保留 data 中 params 的响应式引用，只更新字段
						Object.keys(baseParams).forEach(key => {
							this.$set(this.params, key, baseParams[key])
						})
						this.$set(this.params, 'detailUpdateInput', sources)
						//省市区
						this.initArea(sellOrderResult)
					}
				}
			} catch (err) {
				console.log(err)
			}
		},
		changeWorkOrderCode(workOrderCode) {
			this.params.workOrderCode = workOrderCode
		},
		//编辑时回显省市区
		async initArea(sellOrderResult) {
			let list0 = await this.$api.common.getProvince({
				page: 1,
				limit: 1000
			})
			list0 = (list0 || []).map(a => {
				return {
					label: a.province,
					value: a.provinceId
				}
			})
			let list1 = await this.$api.common.getCity({
				province: sellOrderResult.provinceId
			})
			list1 = (list1 || []).map(a => {
				return {
					label: a.city,
					value: a.cityId
				}
			})
			let list2 = await this.$api.common.getArea({
				city: sellOrderResult.cityId
			})
			list2 = (list2 || []).map(a => {
				return {
					label: a.area,
					value: a.areaId,
					leaf: true
				}
			})
			list1 = list1.map(a => {
				if (a.value === sellOrderResult.cityId) a.children = list2
				return a
			})
			list0 = list0.map(a => {
				if (a.value === sellOrderResult.provinceId) a.children = list1
				return a
			})
			this.casOptions = list0
		},
		// 获取明细在 params.detailUpdateInput 中的索引
		getDetailIndex(row) {
			return this.params.detailUpdateInput.indexOf(row)
		},
		// 根据明细行对象和字段名生成表单校验 prop，如：detailUpdateInput.0.code
		getDetailProp(row, field) {
			const index = this.getDetailIndex(row)
			if (index === -1) return ''
			return `detailUpdateInput.${index}.${field}`
		},
		// 根据 maintenance 字段构建二维分组数组
		buildDetailGroups(sourceList) {
			const list = sourceList || this.params.detailUpdateInput || []
			const maintenanceMap = {}
			list.forEach(item => {
				const key = item.maintenance || '未分类'
				if (!maintenanceMap[key]) {
					maintenanceMap[key] = []
				}
				maintenanceMap[key].push(item)
			})
			this.detailGroups = Object.keys(maintenanceMap).map(k => maintenanceMap[k])
		},
		// 新增一个维修项分组（带一条空明细），维修项名称可编辑
		addGroupEvent() {
			const newItem = {
				reason: '',
				maintenance: '',
				num: '',
				code: '',
				name: '',
				price: '',
				remark: '',
				totalAmount: 0,
				warehouseCode: '',
				warehouseName: '',
				storageCode: '',
				storageName: '',
				inventoryNum: 0
			}
			this.params.detailUpdateInput.push(newItem)
			this.buildDetailGroups()
			// 默认展开新添加的项，并关闭其他项
			this.$nextTick(() => {
				const newGroupIndex = this.detailGroups.length - 1
				this.activeNames = [newGroupIndex]
			})
		},
		// 在指定分组下新增一条明细
		addEvent(group, groupIndex) {
			const maintenance = group && group[0] ? group[0].maintenance : ''
			const newItem = {
				reason: '',
				maintenance,
				num: '',
				code: '',
				name: '',
				price: '',
				remark: '',
				totalAmount: 0,
				warehouseCode: '',
				warehouseName: '',
				storageCode: '',
				storageName: '',
				inventoryNum: 0
			}
			this.params.detailUpdateInput.push(newItem)
			this.buildDetailGroups()
		},
		// 删除指定分组中的一条明细
		deleteEvent(groupIndex, index) {
			const target = this.detailGroups[groupIndex]?.[index]
			if (!target) return
			this.params.detailUpdateInput = this.params.detailUpdateInput.filter(item => item !== target)
			this.buildDetailGroups()
		},
		// 复制指定分组中的一条明细
		copyEvent(groupIndex, index) {
			const target = this.detailGroups[groupIndex]?.[index]
			if (!target) return
			const copy = {
				...target
			}
			this.params.detailUpdateInput.push(copy)
			this.buildDetailGroups()
		},
		submitEvent(submit) {
			if (this.loading) return
			let params = this.$utils.deepClone(this.params)
			if (params.orderTime) {
				params.orderTime = params.orderTime + ' 00:00:00'
			}
			if (params.requireDeliverTime) {
				params.requireDeliverTime = params.requireDeliverTime + ' 23:59:59'
			}
			// 以当前列表为准同步附件/图片；删光后也要清空对应字段，避免草稿旧文件被再次提交
			if (Array.isArray(params.fileList)) {
				params.attachmentUrl = params.fileList.length
					? params.fileList
							.map(a => `${a.url}?fileName=${a.name}`)
							.join(',')
					: ''
				delete params.fileList
			}
			if (Array.isArray(params.imageList1)) {
				params.payUrl = params.imageList1.length
					? params.imageList1
							.map(a => `${a.url}?fileName=${a.name}`)
							.join(',')
					: ''
				delete params.imageList1
			}
			if (Array.isArray(params.imageList2)) {
				params.repairUrl = params.imageList2.length
					? params.imageList2
							.map(a => `${a.url}?fileName=${a.name}`)
							.join(',')
					: ''
				delete params.imageList2
			}
			if (params.specialHas == 0) {
				delete params.specialAmount
				delete params.specialOrderCode
			} else {
				params.specialAmount = Number(params.specialAmount) * 100 //元转分
			}
			//省市区
			if (params.area?.length == 3) {
				params.provinceId = params.area[0]
				params.cityId = params.area[1]
				params.areaId = params.area[2]
			}
			delete params.area
			let detailUpdateInput = params.detailUpdateInput
			
			// 校验：相同code的单价必须一致
			const codePriceMap = {}
			for (let i = 0; i < detailUpdateInput.length; i++) {
				const item = detailUpdateInput[i]
				if (!item.code || !item.price) continue
				
				const code = item.code
				const price = Number(item.price)
				
				if (codePriceMap[code] !== undefined) {
					// 如果已存在该code，检查价格是否一致
					if (codePriceMap[code] !== price) {
						this.$message.warning(`料号 ${code} 的单价不一致，请检查后重新提交`)
						return
					}
				} else {
					// 首次遇到该code，记录价格
					codePriceMap[code] = price
				}
			}
			
			detailUpdateInput = detailUpdateInput.map(a => {
				let price = Number(a.price) * 100 //元转分
				let totalAmount = Number(a.totalAmount) * 100 //元转分
				return {
					...a,
					price,
					totalAmount
				}
			})

			delete params.detailUpdateInput
			let newParams = {
				submit: submit == 1,
				detailUpdateInput: detailUpdateInput,
				updateInput: params
			}
			if (submit === 1) {
				if (this.params.send === 0 && this.params.detailUpdateInput.length === 0) {
					this.$message.warning('请至少添加一条物品清单')
					return
				}
				if (this.nodes.length) {
					let flag = true
					for (let i = 0; i < this.nodes.length; i++) {
						if (
							this.nodes[i].assigneeType == 'SELF_SELECT' &&
							this.nodes[i].userType == 2 &&
							this.nodes[i].users.length == 0 &&
							!this.params?.auditors[this.nodes[i].id]?.length
						) {
							flag = false
							return this.$message.warning('请选择审批人后提交')
						}
					}
					if (!flag) return
				}
				this.$refs['form'].validate(async valid => {
					if (!valid) {
						// 表单校验不过，弹窗提示
						this.$alert('表单校验未通过，请检查必填项。', '提示', {
							type: 'warning'
						})
						return
					}
					try {
						this.loading = true
						clearInterval(this.timeSaveFlag)
						await this.$api.apply.sellOrderSave(newParams)
						//提交成功
						this.submitSuccess('/#/newSellOrderApply')
					} finally {
						this.loading = false
					}
				})
			}
			if (submit === 3) {
				this.$refs['form'].validate(async valid => {
					if (!valid) {
						this.$alert('表单校验未通过，请检查必填项和数量是否超过存货数量。', '提示', {
							type: 'warning'
						})
						return
					}
					try {
						if (this.params.repair === 1) {
							if (this.params.detailUpdateInput.length === 0) {
								this.$message.warning('请至少添加一条物品清单')
								return
							}
						}
						this.loading = true
						await this.$api.apply.sellOrderUpdate(newParams)
						this.$message.success('更新成功')
						// 返回上一页
						this.$router.back()
					} finally {
						this.loading = false
					}
				})
			}
			if (submit === 2 && !this.isUpdate) {
				try {
					this.loading = true
					this.$api.apply.sellOrderSave(newParams).then(result => {
						this.$message.success('保存成功')
					})
				} finally {
					this.loading = false
				}
			}
		},
		//业务员改变
		proposerChange(a) {
			this.$nextTick(() => {
				this.$refs.SelectDepartment?.changeEvent(a.cdepCode)
			})
		},
		//计算小计费用（直接基于行对象计算，保持引用不变，避免分组引用失效）
		computeTotalAmount(row) {
			if (!row) return
			const {
				num,
				price
			} = row
			let totalAmount = 0
			if (!num || !price) {
				totalAmount = 0
			} else {
				totalAmount = Number(num) * Number(price)
			}
			this.$set(row, 'totalAmount', totalAmount)
		}
	}
}
</script>